// TODO: Add meta.scss from DB UI Core after styles are fixed

:host {
  margin-top: auto;
  margin-bottom: auto;
}
